import inputmask from 'inputmask';
import Mediator from 'common/scripts/observer';
import SendFile from '../sendfile';
import Utils from 'common/scripts/utils';

const mediator = new Mediator();
const sendfile = new SendFile();

class Input {
    init(options) {
        this.target = options.target;
        this.required = this._setRequired(options.required);
        this.state = !this.required;
        this.mode = options.mode;
        this.mask = options.mask || false;
        this.wrapper = this.target.closest('.j-input-wrap');
        this.form = options.form;

        if (this.wrapper) {
            this.error = this.wrapper.querySelector('.j-input-error');
            this.buttonClear = this.wrapper.querySelector('.j-input-clear');
        }

        /* eslint-disable no-useless-escape */
        this.regexp = {
            name   : RegExp('^.{2,40}$'),
            message: RegExp(/^.{2,1500}$/s),
            phone  : RegExp('^((\\+7\\s)+([0-9]){3}\\-([0-9]){3}\\-([0-9]){2}-([0-9]){2})$'),
            email  : RegExp('^[-._a-zA-Za-яA-я0-9]{2,}@(?:[a-zA-Za-яА-Я0-9][-a-z-A-Z-a-я-А-Я0-9]+\\.)+[a-za-я]{2,6}$'),
            inn    : RegExp('\\d{4}\\s\\d{4}\\s(\\d{4}|\\d{2})$'),
            fileArh: RegExp('(\.zip|\.rar)$')
        };
        /* eslint-enable */

        this.errorMessageEmpty = 'Введите текст в поле ввода';
        this.errorMessageOption = options.error;
        this.errorMessage = this.errorMessageOption;
        this.typeInput = this.target.type;
        this.maxSizeFile = options.maxSizeFile;

        this._setMode();
    }

    /**
     * Метод устанавливает является ли инпут обязательным к заполнению. По дефолту обязателен.
     * @param {boolean} option - опция из вне.
     * @return {boolean} true - обязателен, false - нет
     * @private
     */
    _setRequired(option) {
        return option !== false;
    }

    /**
     * Метод устанавливает режим валдиации для инпута
     */
    _setMode() {
        switch (this.mode) {
            case 'name':
                this._validateName();
                break;
            case 'message':
                this._validateMessage();
                break;
            case 'phone':
                this._validatePhone();
                break;
            case 'email':
                this._validateEmail();
                break;
            case 'agreement':
                this._validateAgreement();
                break;
            case 'inn':
                this._validateInn();
                break;
            case 'group':
                this._validateGroup();
                break;
            case 'file':
                sendfile.init({
                    form  : this.form,
                    target: this.target
                });
                this._validateFile();
                break;
            default:
                break;
        }
    }

    /**
     * Метод навешивает обработчики событий
     * @param {boolean} submit - флаг, если метод вызывается при самбите формы.
     * @private
     */
    _bindEvents(submit = false) {
        const handler = (event) => {
            const value = event.target.value;

            this._validateLength(value);
            this._validate(value);
        };

        if (submit) {
            this.target.addEventListener('input', handler, false);

            return;
        }

        this.target.addEventListener('blur', (event) => {
            handler(event);

            this.target.addEventListener('input', handler, false);
        });

        if (this.buttonClear) {
            this.buttonClear.addEventListener('click', () => {
                this.clear();
            });
        }
    }

    /**
     * Метод проверки в режиме 'name'.
     * @private
     */
    _validateName() {
        this.defRegexp = this.regexp.name;
        this._bindEvents();
    }

    /**
     * Метод проверки в режиме 'message'.
     * @private
     */
    _validateMessage() {
        this.defRegexp = this.regexp.message;
        this._bindEvents();
    }

    /**
     * Метод проверки в режиме 'phone'.
     * @private
     */
    _validatePhone() {
        this.defRegexp = this.regexp.phone;

        if (this.mask) {
            // Поставит первую 9 при первом фокусе
            let startValue = '';

            this.target.addEventListener('focus', (event) => {
                const value = event.target.value;

                if (value === startValue) {
                    event.target.value = '9';
                    startValue = event.target.value;
                }
            });

            this.target.addEventListener('blur', (event) => {
                const value = event.target.value;

                if (startValue === value) {
                    event.target.value = '';
                    startValue = '';
                }
            });

            inputmask(this.mask).mask(this.target);
        }

        this._bindEvents();
    }

    /**
     * Метод проверки в режиме 'email'.
     * @private
     */
    _validateEmail() {
        this.defRegexp = this.regexp.email;
        this._bindEvents();
    }

    /**
     * Метод проверки в режиме 'agreement'.
     * @private
     */
    _validateAgreement() {
        this.target.addEventListener('change', (event) => {
            const target = event.target;

            if (target.checked) {
                this.throwSuccess();
            } else {
                this.throwError();
            }
        });
    }

    /**
     * Метод проверки в режиме 'inn'.
     * @private
     */
    _validateInn() {
        this.defRegexp = this.regexp.inn;
        this._bindEvents();

        if (this.mask) {
            inputmask(this.mask).mask(this.target);
        }
    }

    /**
     * Метод проверяет длину значения инпута и записывает соотвествующий текст ошибки.
     * @param {string} value - значение текущего инпута
     */
    _validateLength(value) {
        if (value.length) {
            this.errorMessage = this.errorMessageOption;
        } else {
            this.errorMessage = this.errorMessageEmpty;
        }
    }

    /**
     * Метод проверяет расширение файла
     * @param {object} file - объект файла из инпута
     * @private
     */
    _validateExtensions(file) {
        if (!file) {
            return;
        }

        if (this.regexp.fileArh.test(file.name)) {
            this.throwSuccess();
        } else {
            this.errorMessage = 'Возможно загружать файлы только в формате .zip или .rar';
            this.throwError();
        }
    }

    /**
     * Метод проверяет размер файла
     * @param {object} file - объект файла из инпута
     * @private
     */
    _validateFileSize(file) {
        // если формат файла не верный, то на размер проверку не проводим
        if (!file || !this.state) {
            return;
        }

        if (file.size <= this.maxSizeFile) {
            this.throwSuccess();
        } else {
            this.errorMessage = 'Превышен размер файла, максимальный размер 4МБ';
            this.throwError();
        }
    }

    /**
     * Метод проверяет группу инпутов на хоть одно чекнутое состояние.
     */
    _validateGroup() {
        const input = Array.from(this.target.querySelectorAll('input'));

        // если хоть один элемент массива не чекнут, то общее состояние = false
        const checkState = () => {
            return input.some((item) => {
                return item.checked;
            });
        };

        if (checkState()) {
            this.state = true;
        }

        input.forEach((item) => {
            item.addEventListener('change', () => {
                return checkState() ? this.throwSuccess() : this.throwError();
            });
        });
    }

    /**
     * Метод проверки в режиме 'file'.
     * @private
     */
    _validateFile() {
        this.target.addEventListener('change', () => {
            const first = 0;
            const file = this.target.files[first];

            this._validateExtensions(file);
            this._validateFileSize(file);

            if (this.state) {
                sendfile.upload(file);
                this.target.value = '';
            }
        });
    }

    /**
     * Метод проверки соответствия регулярного выражения и значения инпута.
     * @param {string} value - значение инпута.
     * @private
     */
    _validate(value) {
        if (!this.required && !value.length) {
            this.throwSuccess(true);

            return;
        }

        if (this.defRegexp.test(value)) {
            this.throwSuccess();
        } else {
            this.throwError();
        }

        mediator.publish('inputValidate', this);
    }

    /**
     * Метод устанавливает положительный результат валидации, и скрывает сообщение об ошибке.
     * @param {boolean} remove - флаг обозначающий, что нужно удалить все следы валидации.
     * @public
     */
    throwSuccess(remove = false) {
        this.state = true;
        this.wrapper.classList.remove('has-error');
        this.wrapper.classList.add('has-success');

        if (remove) {
            this._removeValidate();
        }
    }

    /**
     * Метод устанавливает отрицательный результат валидации, и показывает сообщение об ошибке.
     * @param {HTMLInputElement} item - инпут который не прошел валидация при сабмите.
     * @public
     */
    throwError(item = null) {
        this.state = false;
        this.wrapper.classList.add('has-error');
        this.wrapper.classList.remove('has-success');

        if (item && this.mode !== 'agreement' && this.mode !== 'group' && this.mode !== 'file') {
            this._validateLength(item.target.value);
            this._bindEvents(true);
        }

        if (item && this.mode === 'agreement') {
            item.target.classList.add('has-error');
            item.target.classList.remove('has-success');
        }


        if (item && this.mode === 'file') {
            const first = 0;

            this._validateLength(item.target.value);
            this._validateExtensions(this.target.files[first]);
            this._validateFileSize(this.target.files[first]);
        }

        Utils.clearHtml(this.error);
        Utils.insetContent(this.error, this.errorMessage);
    }

    /**
     * Скрывает визуальные следы валидации
     * @private
     */
    _removeValidate() {
        this.wrapper.classList.remove('has-error');
        this.wrapper.classList.remove('has-success');
    }

    /**
     * Очищает инпут и сбрасывает валидацию
     * @public
     */
    clear() {
        if (this.mode === 'phone') {
            this.target.value = '9';
        } else {
            this.state = false;
            this.target.value = '';
        }

        this._removeValidate(true);
    }
}

export default Input;
